import dayjs from 'dayjs';
import store from '../redux/store';
import utc from 'dayjs/plugin/utc';
import { resetSiteLevelDate } from '../redux/slice/cartSlice';

dayjs.extend(utc);

export const checkInvalidStartDate = (startDate: number, timezone: string) => {
  const minStartDate = dayjs().utc().add(1, 'day').startOf('day').tz(timezone);
  const timestampInTimezone = dayjs.unix(startDate).utc().tz(timezone);

  return timestampInTimezone.isBefore(minStartDate, 'date');
};

export const initSiteLevelDate = () => {
  const siteLevelDate = store.getState().cart.siteLevelDate;
  const cartLength = store.getState().cart.cartItems.length;
  if (siteLevelDate && cartLength) {
    const today = dayjs().startOf('day');
    const updatedOnDate = dayjs.unix(siteLevelDate.updatedOn);
    const isSameDay = updatedOnDate.isSame(today, 'day');

    if (!isSameDay) {
      store.dispatch(resetSiteLevelDate());
    }
  }
};
